import { SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { OnInit } from '@angular/core';
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent() {
        this.pageChange = new EventEmitter();
    }
    Object.defineProperty(PaginationComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (page) {
            if (this._page !== page) {
                this._page = page;
                this.pageChange.emit(page);
            }
        },
        enumerable: true,
        configurable: true
    });
    PaginationComponent.prototype.ngOnInit = function () {
        this.count = +this.count;
        this.page = +this.page;
        this.step = +this.step;
        this.pagesCount = Math.ceil(this.count / this.step);
        this.pages = this._generatePages();
    };
    PaginationComponent.prototype.ngOnChanges = function (changes) {
        if (changes['count']) {
            this._setPagesCount();
            this.pages = this._generatePages();
        }
    };
    PaginationComponent.prototype._setPagesCount = function () {
        this.pagesCount = Math.ceil(this.count / this.step);
    };
    PaginationComponent.prototype.isPage = function (page) {
        return (this.page === page);
    };
    PaginationComponent.prototype.setPage = function (page) {
        if (page !== this.page && page >= 1 && page <= this.pagesCount) {
            this.page = page;
            this.pages = this._generatePages();
        }
    };
    PaginationComponent.prototype._generatePages = function () {
        var pages = [];
        if (this.pagesCount > 1) {
            if (this.pagesCount < 10) {
                for (var i = 0; i < this.pagesCount; i++) {
                    pages.push(i + 1);
                }
            }
            else {
                pages.push(1);
                if (this.page < 5) {
                    pages.push(2, 3, 4, 5);
                }
                pages.push(null);
                if (this.page + 5 > this.pagesCount) {
                    pages.push(this.pagesCount - 4, this.pagesCount - 3, this.pagesCount - 2, this.pagesCount - 1);
                }
                else if (this.page > 4) {
                    pages.push(this.page - 1, this.page, this.page + 1, null);
                }
                pages.push(this.pagesCount);
            }
        }
        return pages;
    };
    return PaginationComponent;
}());
export { PaginationComponent };
